import { render, staticRenderFns } from "./FamilyMapping.vue?vue&type=template&id=42cc19dd&"
import script from "./FamilyMapping.vue?vue&type=script&lang=js&"
export * from "./FamilyMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports